<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Aguarde ...</p>
  </ngx-spinner>
  
  <div class="row">
    <div class="col-12">
      <app-card  [options]="false" [hidHeader]="true">
        <div class="row">
          <div class="col-sm-12 col-xl-4 ">
            <label class="sub-title">Filtro</label>
            <input type="text" class="form-control" [(ngModel)]="filtro">
          </div>
        </div>
  
  
  
      </app-card>
    </div>
    <div class="col-12">
      <app-card cardTitle="Responsável Cadastrado" blockClass="table-border-style" [options]="false">
        <div class="list-group list-group-flush">
          <div class="list-group-item" *ngFor="let item of arrayParticipante | fullTextSearch:filtro">
            <div class="row">
              <div class="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Nome</small>
                <span class="font-weight-semibold d-block">{{item.nome }}</span>
              </div>
              <div class="col-6 col-md-2 col-lg-1 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Idade</small>
                <span>{{item.idade }}</span>
              </div>
              <div class="col-6 col-md-2 col-lg-1 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Sexo</small>
                <span>{{item.sexo }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Data Nasc.</small>
                <span>{{item.datA_NASCIMENTO | date: "dd/MM/yyyy HH:mm:ss"}}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Grau TEA</small>
                <span class="d-block text-break">{{item.graU_TEA }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 mb-3 mb-lg-0">
                <small class="text-uppercase text-muted d-block">Escola</small>
                <span class="d-block text-break">{{item.ondE_ESTUDOU }}</span>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Turno</small>
                <span class="d-block text-break">{{item.turno }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Responsável Nome</small>
                <span class="d-block text-break">{{item.responsaveL_NOME }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Responsável CPF</small>
                <span class="d-block text-break">{{item.responsaveL_CPF }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-2 mb-3 mb-md-0">
                <small class="text-uppercase text-muted d-block">Cartão SUS</small>
                <span class="d-block text-break">{{item.cartaO_SUS }}</span>
              </div>
              <div class="col-12 col-md-4 col-lg-3 text-md-right">
                <small class="text-uppercase text-muted d-block">Laudo</small>
                <button *ngIf="item.patH_LAUDO" type="button" class="btn btn-warning btn-sm mt-1"
                  (click)="verArquivo(item)">
                  <i class="fa fa-eye"></i> Visualizar
                </button>
              </div>
            </div>
          </div>
        </div>
      </app-card>
    </div>
  </div>
  